/**
 * Filtro da pesquisa de alunos, compartilhado entre a Consulta de Alunos e a
 * modal de pesquisa usada na venda avulsa — as duas telas precisam achar o
 * aluno pelos mesmos campos.
 *
 * Busca por nome, e-mail, unidade, turma, status, matrícula, responsável e dono
 * do cheque (texto) e por CPF/celular (só os dígitos).
 *
 * `considerarStatus` fica ligado por padrão; a Consulta de Alunos o desliga
 * porque lá o status virou um filtro próprio, de seleção múltipla.
 */
export function filtrarAlunos<T extends Record<string, any>>(
  alunos: T[],
  termo: string,
  { considerarStatus = true }: { considerarStatus?: boolean } = {}
): T[] {
  const term = (termo || '').trim().toLowerCase();
  if (!term) return alunos;

  const termDigits = term.replace(/\D/g, '');

  return alunos.filter((aluno: any) => {
    // `donosCheque` traz o nome do dono de todos os cheques do aluno; o
    // `donoCheque` (só o primeiro) continua na lista por compatibilidade.
    const donosCheque: string[] = Array.isArray(aluno?.donosCheque) ? aluno.donosCheque : [];
    const fields = [
      aluno?.nome,
      aluno?.email,
      aluno?.unidadeNome,
      aluno?.turmaNome,
      ...(considerarStatus ? [aluno?.statusNome] : []),
      aluno?.matricula,
      aluno?.responsavelNome,
      aluno?.donoCheque,
      ...donosCheque
    ];
    const textMatch = fields.some(
      (value) => value != null && String(value).toLowerCase().includes(term),
    );
    if (textMatch) return true;
    if (termDigits.length > 0) {
      const cpfDigits = String(aluno?.cpf ?? '').replace(/\D/g, '');
      const celularDigits = String(aluno?.celular ?? '').replace(/\D/g, '');
      if (cpfDigits.includes(termDigits) || celularDigits.includes(termDigits)) {
        return true;
      }
    }
    return false;
  });
}
